<div class="generic-stepper__container content steps"
     *ngIf="displayStepper"
     [ngClass]="'layout-align-'+layoutAlign+ ' layout-'+layout"
     fxFlex
     [fxLayout]="layout"
     [fxLayoutAlign]="layoutAlign">

    <ng-container *ngIf="options.isListFormatStepper">
        <div class="generic-stepper__left-toolbar">
            <ng-content select="[toolbar-before-stepper]"></ng-content>
        </div>
        <button class="generic-stepper__previous-button previous"
                [ngStyle]="{'visibility' : isPreviousVisible()?'visible':'hidden'}"
                [disabled]="isLocked"
                (click)="previous()"
                [attr.aria-label]="'generic.previous' | translate"
                [matTooltip]="'generic.previous' | translate">
            <mat-icon svgIcon="arrow_left"></mat-icon>
        </button>
        <mat-form-field *ngIf="options.steps.length > 1"
                        class="generic-stepper__select-field"
                        appearance="fill">
            <mat-select panelClass="generic-stepper__select-panel"
                        [(value)]="selectedStep"
                        (selectionChange)="clickOnElem($event.value)"
                        [disabled]="isLocked">
                <mat-option *ngFor="let step of options.steps"
                            [value]="step">
                    {{getLabelToDisplay(step)}} / {{options.steps.length}} - {{stepTitle(step)}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button class="generic-stepper__next-button next"
                [ngStyle]="{'visibility' : isNextVisible()?'visible':'hidden'}"
                [disabled]="isLocked || isLockedNext"
                (click)="next()"
                [attr.aria-label]="'generic.next' | translate"
                [matTooltip]="'generic.next' | translate">
            <mat-icon svgIcon="arrow_right"></mat-icon>
        </button>
        <div class="generic-stepper__right-toolbar">
            <ng-content select="[toolbar-after-stepper]"></ng-content>
        </div>
    </ng-container>

    <div *ngIf="options.recap.isAllowed"
         [ngClass]="{'active':options.recap.isActive }"
         (click)="clickOnElem(null)"
         fxLayoutAlign="space-evenly center"
         class="step">
        <mat-icon class="number flag"
                  svgIcon="flag">
        </mat-icon>
        <mat-icon *ngIf="options.recap.isArrowActive"
                  class="arrow"
                  [ngClass]="arrowPositionClass"
                  svgIcon="arrow_right">
        </mat-icon>
    </div>

</div>